import moment from "moment";
import React from "react";
import Slider from "../../../../../../../../../../Components/Slider";
import ReactPlayer from "react-player";
import { SwiperSlide } from "swiper/react";
import './style.css'
import Carousel from "../../../../../../../../../../Components/Carousel";
import { getGrade } from "../../../../../../../../../../helper/index"

const Activity = ({ data, id, deleteSubmission, review_submission }) => {

  const options = {
    slidesPerView: 1,
    spaceBetween: 0,
    className: "mySwiper",
  };

  const grade = getGrade(data?.grade);
  const myBreakpoints = {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  };

  const handleFilePreview = url => window.open(url, "_blank");

  return (
    <React.Fragment>
      <div className="video-sec mb-5">
        <h5 className="fw-semibold">{data?.activityName}</h5>
        <h6 className="mt-4 mb-2 fw-semibold">
          Submission : <b>Submitted on {moment(data?.createdAt).format("DD MMM YYYY")}</b>
        </h6>
        <div className="activity-slider submission-data">
          <div className={`text-end mb-1 text-${grade?.color}`}>
            {grade?.resubmission && <span className={`dot bg-${grade?.color} text-white`}>R</span>} {grade?.grade}
          </div>
          <Carousel id={`activity${id}`} newOptions={options} brekpoints={myBreakpoints}>
            {data?.fileUrlDtoList?.map((item, key) => {
              return (
                <SwiperSlide key={key}>
                  {item?.fileType?.toLowerCase() === "pdf" && <div className="card-img" onClick={() => handleFilePreview(item?.fileUrl)}><img src={item?.thumbUrl} class="card-img-top" alt="dice" /></div>}
                  {item?.fileType?.toLowerCase() === "image" && <div className="card-img" onClick={() => handleFilePreview(item?.fileUrl)}><img src={item?.fileUrl} class="card-img-top" alt="dice" /></div>}
                  {item?.fileType?.toLowerCase() === "video" && <div className="card-img"><ReactPlayer url={item?.fileUrl} controls={true} width={"100%"} height={"560px"} /></div>}
                </SwiperSlide>
              )
            })}
            {/* {Object.entries(data?.submissionUrls)?.map(([url, type], index) => {
              return (
                <SwiperSlide key={index}>
                  {type === "Image" && <div className="card-img"><img src={url} class="card-img-top" alt="dice" /></div>}
                  {type === "Video" && <div className="card-img"><ReactPlayer url={url} controls={true} width={"100%"} height={"560px"} /></div>}
                </SwiperSlide>
              )
            })} */}
          </Carousel>
          <div className="row text-end mt-2">
            <div className="col-md-6 offset-6 submissions-btns">
              {data?.deleteAllowed?.status && <button className="btn btn-primary btn-theme mx-2" onClick={() => deleteSubmission(data)}>Delete this submission</button>}
              {data?.reviewAllowed?.status && <button className="btn btn-primary btn-theme" onClick={() => review_submission(data)}>Raise a review Request</button>}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Activity;
